export default "__VITE_ASSET__CNjsNuea__"